/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILdsErrorData } from './lds-error.data';
import { ILdsErrorProps } from './lds-error.props.autogenerated';

export interface ILdsErrorViewProps extends ILdsErrorProps<ILdsErrorData> {}

/**
 *
 * LdsWarn component
 * @extends {React.PureComponent<ILdsErrorProps<ILdsErrorData>>}
 */
class LdsWarn extends React.PureComponent<ILdsErrorProps<ILdsErrorData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LdsWarn;
